export const isFutureDate = (dateString: string): boolean => {
  const inputDate = new Date(dateString)
  const today = new Date()

  // 時刻の影響を除くため、両方00:00:00に揃える
  inputDate.setHours(0, 0, 0, 0)
  today.setHours(0, 0, 0, 0)

  return inputDate > today
}

export const isValidYyyyMmDdFormat = (dateString: string): boolean => {
  const regex = /^\d{4}-\d{2}-\d{2}$/
  if (!regex.test(dateString)) return false

  const date = new Date(dateString)
  const [year, month, day] = dateString.split('-').map(Number)

  return (
    date.getFullYear() === year &&
    date.getMonth() + 1 === month &&
    date.getDate() === day
  )
}

export const compareDateYmd = (
  inputDate: string | Date,
  baseDate: string | Date = new Date(),
): -1 | 0 | 1 => {
  const toDateOnly = (d: string | Date): Date => {
    const date = typeof d === 'string' ? new Date(d) : d
    date.setHours(0, 0, 0, 0)
    return date
  }

  const d1 = toDateOnly(inputDate)
  const d2 = toDateOnly(baseDate)

  if (d1.getTime() < d2.getTime()) return -1
  if (d1.getTime() > d2.getTime()) return 1
  return 0
}
